import { ExamState, ExamAction } from "../sample data/Type";

export const initialState: any = {
  currentSectionIndex: 0,
  currentQuestionIndex: 0,
  answers: {},
  timeRemaining: 0,
  isCalculatorOpen: false,
  isNavigatorOpen: false,
};

export function examReducer(state: ExamState, action: ExamAction): ExamState {
  switch (action.type) {
    case "START_SECTION":
      return { ...state, timeRemaining: action.time, currentQuestionIndex: action.index ?? 0 };

    case "NEXT_QUESTION":
      return { ...state, currentQuestionIndex: state.currentQuestionIndex + 1 };

    case "PREV_QUESTION":
      return { ...state, currentQuestionIndex: Math.max(0, state.currentQuestionIndex - 1) };

    case "SELECT_ANSWER":
      return {
        ...state,
        answers: {
          ...state.answers,
          [action.questionId]: {
            ...state.answers[action.questionId],
            selectedOptionIndex: action.optionIndex,
          },
        },
      };

    case "SET_DRAG_DROP_ANSWER": {
      const currentAnswers = { ...(state.answers[action.questionId]?.dragDropAnswers || {}) };

      // If exclusive mode is on (SJT mode), ensure only one item per bucket.
      if (action.isExclusive && action.bucketName !== null) {
        Object.keys(currentAnswers).forEach((idKey) => {
          const id = Number(idKey);
          if (currentAnswers[id] === action.bucketName && id !== action.itemId) {
            currentAnswers[id] = null;
          }
        });
      }

      return {
        ...state,
        answers: {
          ...state.answers,
          [action.questionId]: {
            ...state.answers[action.questionId],
            dragDropAnswers: {
              ...currentAnswers,
              [action.itemId]: action.bucketName,
            },
          },
        },
      };
    }

    case "TOGGLE_FLAG":
      return {
        ...state,
        answers: {
          ...state.answers,
          [action.questionId]: {
            ...state.answers[action.questionId],
            isFlagged: !state.answers[action.questionId]?.isFlagged,
          },
        },
      };

    case "TICK_TIMER":
      return { ...state, timeRemaining: Math.max(0, state.timeRemaining - 1) };

    case "TOGGLE_CALCULATOR":
      return { ...state, isCalculatorOpen: !state.isCalculatorOpen };

    case "TOGGLE_NAVIGATOR":
      return { ...state, isNavigatorOpen: !state.isNavigatorOpen };

    case "JUMP_QUESTION":
      return { ...state, currentQuestionIndex: action.index };

    case "VIEW_QUESTION":
      return {
        ...state,
        answers: {
          ...state.answers,
          [action.questionId]: {
            ...state.answers[action.questionId],
            isViewed: true,
          },
        },
      };

    case "LOAD_EXISTING_ANSWERS": {
      const newAnswers = { ...state.answers };
      Object.keys(action.answers).forEach((id) => {
        const questionId = Number(id);
        newAnswers[questionId] = {
          ...newAnswers[questionId],
          ...action.answers[questionId],
          // Ensure isViewed stays true if it ever was true
          isViewed: newAnswers[questionId]?.isViewed || action.answers[questionId]?.isViewed,
        };
      });
      return {
        ...state,
        answers: newAnswers,
      };
    }

    default:
      return state;
  }
}